import React from 'react'
import styled from 'styled-components'

import Tools from '../Tools'
import Nav from '../Nav'

const Overlay = styled.div`
  position: fixed;
  top: ${({ theme }) => theme.navHeight};
  left: 0;
  z-index: 5050;
  display: ${({ open }) => (open ? 'flex' : 'none')};
  width: 100%;
  height: calc(100% - ${({ theme }) => theme.navHeight});
  flex-direction: column;
  justify-content: flex-end;
  padding: 0 34px 56px;
  background: #ffffff;
`

const MobileNavOverlay = ({ open }) => (
  <Overlay open={open}>
    <Tools />
    <Nav />
  </Overlay>
)

export default MobileNavOverlay



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout/components/NavBar/components/MobileNavOverlay/index.js